import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

interface AppState {
    sidebarOpen: boolean
    toggleSidebar: () => void
    setSidebarOpen: (open: boolean) => void
}

export const useAppStore = create<AppState>()(
    devtools(
        (set) => ({
            sidebarOpen: true,
            toggleSidebar: () =>
                set((state) => ({ sidebarOpen: !state.sidebarOpen }), false, 'app/toggleSidebar'),
            setSidebarOpen: (open) =>
                set({ sidebarOpen: open }, false, 'app/setSidebarOpen'),
        }),
        {
            name: 'app-store',
        }
    )
)